import PropTypes from 'prop-types';
import React from 'react';

import styles from './robot-selector.css';

const RobotSelector = ({currentRobot, label, onChange}) => {
    const robotsList = [];
    
    let robots = [];
    try {
        robots = JSON.parse(sessionStorage.getItem('users_robots'));
    } catch (e) {
        throw e; // users_robots が不正な場合はエラーを投げる
    }
    if (robots){
        robots.forEach(robot =>
            robotsList.push({
                text: robot.systemStatus.name,
                value: robot.cdid
            })
        );
    }

    return (
        <select
            aria-label={label}
            className={styles.robotSelect}
            value={currentRobot}
            onChange={onChange}
        >
            {
                robotsList
                    .map(robot => (
                        <option
                            key={robot.value}
                            value={robot.value}
                        >
                            {robot.text}
                        </option>
                    ))
            }
        </select>
    );
};

RobotSelector.propTypes = {
    currentRobot: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func
};

export default RobotSelector;
